import { render, staticRenderFns } from "./PatientCredential.vue?vue&type=template&id=a97c66f4&scoped=true&lang=pug"
import script from "./PatientCredential.vue?vue&type=script&lang=js"
export * from "./PatientCredential.vue?vue&type=script&lang=js"
import style0 from "./PatientCredential.vue?vue&type=style&index=0&id=a97c66f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c66f4",
  null
  
)

export default component.exports